import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    DataTableSelectColumnDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";

const stylesheet = StyleSheet.create({
    container: {
        flexShrink: 0
    }
});

export const useStyles = ({
    selectWidth
}: DataTableSelectColumnDynamicStyleType) => {
    const styles = {
        container: {
            width: selectWidth
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
